<template>
  <v-card class="json-path tools-view-card">
    <ToolbarHeader :name="'ExplanationUI'" />
    <v-container>
      <section class="ma-5">
        <label> JSON </label>
        <editor
          v-model="input"
          @init="initJSONEditor"
          lang="javascript"
          theme="chrome"
          width="100%"
          height="60vh"
        >
        </editor>

        <v-btn type="button" @click="process()" color="primary">
          Process
        </v-btn>

        <h5 class="mt-5">Result</h5>
        <div class="res">
          <QsFExplainUI :sourceData="JsonData" v-if="JsonData && !error"/>
        </div>
      </section>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import { aceEditorMixin } from "@/mixins/aceEditorMixin";
import QsFExplainUI from '@/components/QSFExplainUI/QsfExplain'
export default {
  name: "QSFExplainUI",
  mixins: [aceEditorMixin],
  components: {
    ToolbarHeader,
    QsFExplainUI
  },
  data: () => ({
    input: "",
    JsonData: null,
    error: "",
  }),
  methods: {
    process() {
      try {
        this.error = "";
        this.JsonData = JSON.parse(this.input);
      } catch (e) {
        this.error = e.message;
      }
    },
  },
};
</script>

<style type="text/css" scoped>
.res {
  width: 100%;
}
</style>
